import React from "react";
import Accordion from "./Accordion/Accordion";
import { CustomDiv } from "../../style/shared";

import Advertise from "../../assets/Ads/vertical2.jpeg";
import { CustomLinkBut, ADImage } from "../../style/Dashboard";
import { verifyAuth } from "../../authverify";
import { useHistory } from "react-router-dom";
import "../Sidebar/sidebar.css";
import Horizontal from "../../assets/Ads/Horizontal.jpeg";
import { CustomLinkButLink } from "../../style/Button";
import { Grid } from "@material-ui/core";
export const Dashboard = ({ verticalCreative, reactCreative }) => {
  const history = useHistory();

  if (!verifyAuth()) {
    history.push({
      pathname: "/",
    });
  }
  return (
    <div style={{ width: "100%" }}>
      <Grid container style={{
        paddingBottom: "100px",
      }}>
        <Grid lg={`${verticalCreative ? 9 : 12}`} md={`${verticalCreative ? 12 : 12}`} xs={12} >
          <div className="accordianSectionGrid">
            <Accordion reactCreative={reactCreative} />
          </div>
          <div style={{ marginTop: 0 }} className="text-right">
            <CustomLinkButLink
              className="button"
              style={{ marginBottom: "15px" }}
              to="/Calender"
            >
              Back
            </CustomLinkButLink>
            <CustomLinkButLink
              className="button"
              style={{ marginBottom: "15px" }}
              to="/People/Consultation"
            >
              Next
            </CustomLinkButLink>
          </div>

        </Grid>

        {
          verticalCreative &&
          <Grid item
            lg={3} md={12} xs={12}
            className="rightIframe  d-flex justify-content-end">
            <div className='responsiveMargin'  style={{ maxWidth: '300px', minHeight: '600px', }}>
              <iframe
                title="iframe"
                srcDoc={verticalCreative}
                style={{
                  width: '100%',
                  height: '100%',
                  maxWidth: '100%',
                  minHeight: '600px',
                  marginBottom: "30px"
                }}
                frameBorder="0"
                scrolling="no"
              />
            </div>
          </Grid>

        }

      </Grid>
    </div >
  );
};
